import { render, staticRenderFns } from "./ClipboardItemCard.vue?vue&type=template&id=2661633e&scoped=true"
import script from "./ClipboardItemCard.vue?vue&type=script&lang=js"
export * from "./ClipboardItemCard.vue?vue&type=script&lang=js"
import style0 from "./ClipboardItemCard.vue?vue&type=style&index=0&id=2661633e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661633e",
  null
  
)

export default component.exports